export default "__VITE_ASSET__35e0e805__"